import React from 'react';
import { useChatStore } from '@/store';
import SubscriptionSetting from './setting';
import SubscriptionRecord from './record';


/**
 * 我的订阅
 * @returns 
 */
const Subscription = () => {
  const { activeContentType } = useChatStore();
  
  if (activeContentType === 'setting') {
    return <SubscriptionSetting />;
  }

  return <SubscriptionRecord />;
};

export default Subscription;